import { render, staticRenderFns } from "./SubMenuItemFooter.vue?vue&type=template&id=3f091806&scoped=true&"
import script from "./SubMenuItemFooter.vue?vue&type=script&lang=js&"
export * from "./SubMenuItemFooter.vue?vue&type=script&lang=js&"
import style0 from "./SubMenuItemFooter.vue?vue&type=style&index=0&id=3f091806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f091806",
  null
  
)

export default component.exports